'use client'

import { cn } from '@/lib/utils'
import { Button } from '@components/button'
import {
  ArtBlocksWordmarkLockupFullColor,
  BodyText,
  DetailText,
  HeadlineText,
  JumboText
} from 'design-configuration/components'
import { useSession } from 'next-auth/react'
import Image, { StaticImageData } from 'next/image'
import React from 'react'
import { useClient } from 'urql'
import { usePublicClient } from 'wagmi'
import accountPromo from './assets/accountPromo.jpg'
import achievementsPromo from './assets/achievementsPromo.jpg'
import setsPromo from './assets/setsPromo.jpg'
import { onboardingStore } from './store'

function WelcomeCard({
  image,
  description,
  className
}: {
  image: StaticImageData
  description: string
  className?: string
}) {
  return (
    <div className={cn('border-outline-variant rounded-xs bg-surface-low border', className)}>
      <div className="relative h-32">
        <div className="px-2xs rounded-xs bg-surface-inverted absolute left-1 top-1 z-10 py-[2px]">
          <DetailText className="text-on-surface-inverted font-medium uppercase">New</DetailText>
        </div>
        <Image src={image} alt={description} fill className="object-cover" sizes="16vw" quality={85} />
      </div>
      <div className="px-xs py-sm border-outline-variant border-t">
        <BodyText className="text-center">{description}</BodyText>
      </div>
    </div>
  )
}

export function WelcomeStep(): React.ReactNode {
  const { data: session } = useSession()
  const publicClient = usePublicClient()
  const urqlClient = useClient()

  return (
    <div className="flex h-full flex-col overflow-auto">
      <div className="relative flex-1">
        <div className="p-md">
          <div className="mb-md mt-sm">
            <ArtBlocksWordmarkLockupFullColor className="h-xl fill-on-surface" />
          </div>
          <div>
            <JumboText className="mb-xs block font-medium sm:hidden lg:block">
              Collect.
              <br />
              Curate.
              <br />
              Celebrate.
            </JumboText>
            <JumboText className="mb-xs hidden font-medium md:block lg:hidden">
              Collect. Curate.
              <br /> Celebrate.
            </JumboText>
            <JumboText className="mb-xs hidden font-medium sm:block md:hidden">Collect. Curate. Celebrate.</JumboText>
            <HeadlineText className="mb-md font-light">Show off a profile worthy of your collection</HeadlineText>
            <div className="gap-sm md:gap-xs flex flex-col md:flex-row">
              <WelcomeCard
                className="flex-1"
                image={accountPromo}
                description="View your entire collection no matter where you keep your art"
              />
              <WelcomeCard
                className="flex-1"
                image={achievementsPromo}
                description="Celebrate achievements from your collector journey "
              />
              <WelcomeCard
                className="flex-1"
                image={setsPromo}
                description="Build your Art Blocks sets and discover communities"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="p-md flex items-center justify-between">
        <button className="text-body text-on-surface" onClick={() => onboardingStore.trigger.close()}>
          Skip
        </button>
        <Button
          colorTheme={'primary'}
          branded
          onClick={() => {
            if (!session || !publicClient || !urqlClient) {
              return
            }

            onboardingStore.trigger.welcomeStepCompleted()
          }}
        >
          Get Started
        </Button>
      </div>
    </div>
  )
}
